import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldFilterPipe } from './field-filter.pipe';
import { MomentPipe } from './moment.pipe';
import { SafePipe } from './safe.pipe';
import { FieldItemRemovePipe } from './field-item-remove.pipe';
import { CamelToTextPipe } from './camel-to-text.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [FieldFilterPipe, FieldItemRemovePipe, MomentPipe, SafePipe, CamelToTextPipe],
  exports: [FieldFilterPipe, FieldItemRemovePipe, MomentPipe, SafePipe, CamelToTextPipe]
})
export class PipesModule { }
